var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('b-container',{staticClass:"wrapper-menu",attrs:{"id":"wrapper-menu","fluid":""}},[_c('loading-panel'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }